<template>
  <div
    class="relative flex min-h-12 items-center rounded-5 border border-gray-200 px-3"
  >
    <icon-base
      class="mr-2"
      height="12"
      width="7"
      icon="drag-handle"
      viewBox="0 0 12 20"
    />
    <span class="min-h-12 border-l border-gray-200 p-3 text-gray-500">
      {{ title }}
    </span>
    <div
      v-if="showDynamicSetting"
      class="absolute right-2 bottom-1/2 translate-y-2-5 transform text-gray-600"
      :class="bpOfferField.dynamic ? 'text-primary' : ''"
      @click="changeDynamic"
    >
      <icon-base
        class="cursor-pointer"
        :icon="IconConfigure"
        width="12"
        height="12"
      />
    </div>
  </div>
</template>
<script setup lang="ts">
import { type Ref, computed, inject, ref } from "vue";

import { OfferTemplateView } from "@/enums/offerTemplates";
import { FieldType } from "@/enums/offers";

import IconConfigure from "@/components/icons/IconConfigure.vue";

import type { OfferTemplateField } from "@/models/offers";

const emit = defineEmits<{
  (eventName: "update-dynamic-field", id: string): void;
}>();

const props = defineProps<{
  bpOfferField: OfferTemplateField;
  showDynamicOffer: boolean;
}>();

const templateView = inject<Ref<OfferTemplateView>>(
  "offerTemplateView",
  ref(OfferTemplateView.BP_OFFER_DETAILS)
);

const dynamicSettingForFieldType = [
  FieldType.CURRENCY,
  FieldType.INTEGER,
  FieldType.FLOAT,
  FieldType.PERCENT,
  FieldType.OPTIONS,
];

const showDynamicSetting = computed(
  () =>
    props.showDynamicOffer &&
    props.bpOfferField.name !== "note" &&
    dynamicSettingForFieldType.includes(props.bpOfferField.type)
);

const fieldCategory = computed(() =>
  templateView.value === OfferTemplateView.BP_OFFER_DETAILS
    ? OfferTemplateView.OFFER
    : OfferTemplateView.CLOSING
);

const title = computed(
  () => props.bpOfferField[fieldCategory.value].label ?? ""
);

const changeDynamic = () => {
  emit("update-dynamic-field", props.bpOfferField.id || "");
};
</script>
